
import restService from "../rest-service/RestService";
import { AlarmNotificationsType, IAlarmNotificationCountModel, IAlarmNotificationDetailModel, IAlarmNotificationObjectCountModel, IQueryAlarmNotificationParams } from "./Models";

interface IQueryStringParam {
    contextGroupID: number
}

const AlarmDataService = {

    queryAlarmSetpointNotificationCounts: async function (
        type: AlarmNotificationsType,
        organizationID: number,
        contextGroupID: number,
        startDate: Date,
        endDate: Date,
        //queryParams: IQueryAlarmNotificationParams,
        signal?: AbortSignal
    ): Promise<IAlarmNotificationObjectCountModel> {

        const path = type === AlarmNotificationsType.Setpoints ?
                         `/organizations/${organizationID}/alarms/notifications/setpoints/counts` :
                     type === AlarmNotificationsType.Objects ?
                         `/organizations/${organizationID}/alarms/notifications/objects/counts` :
                         `/organizations/${organizationID}/alarms/notifications/recipients/counts`;

        const queryStringParams = {
            contextGroupID: contextGroupID
        };


        const queryParams: IQueryAlarmNotificationParams = {
            startDate: startDate,
            endDate: endDate,
            filterToGroup: true
        }

        const response = await restService.post<IQueryAlarmNotificationParams, 
                                                IAlarmNotificationObjectCountModel, 
                                                IQueryStringParam>
                                        (path, queryParams, signal, undefined, queryStringParams);

        return response.data;
    },

    queryAlarmNotificationCounts: async function (organizationID: number, 
        contextGroupID: number, 
        startDate: Date,
        endDate: Date,
        //queryParams: IQueryAlarmNotificationParams,
        signal?: AbortSignal): Promise<IAlarmNotificationCountModel[]> {
    
        const path = `/organizations/${organizationID}/alarms/notifications/counts`;

        const queryStringParams = {
            contextGroupID: contextGroupID
        };

        
        const queryParams: IQueryAlarmNotificationParams = {
            startDate: startDate,
            endDate: endDate,
            filterToGroup: true
        }


        const response = await restService.post<IQueryAlarmNotificationParams, 
                                            IAlarmNotificationCountModel[], 
                                            IQueryStringParam>
                                        (path, queryParams, signal, undefined, queryStringParams);

        return response.data;
    },

    queryAlarmNotificationDetail: async function (organizationID: number,
    contextGroupID: number,
    startDate: Date,
    endDate: Date,
    signal?: AbortSignal): Promise<IAlarmNotificationDetailModel[]> {


        const path = `/organizations/${organizationID}/alarms/notifications/detail`;

        const queryStringParams = {
            contextGroupID: contextGroupID
        };

        const queryParams: IQueryAlarmNotificationParams = {
            startDate: startDate,
            endDate: endDate,
            filterToGroup: true
        }


        const response = await restService.post<IQueryAlarmNotificationParams, 
                                            IAlarmNotificationDetailModel[], 
                                            IQueryStringParam>
                                        (path, queryParams, signal, undefined, queryStringParams);

        return response.data;

        
    }
};

export default AlarmDataService;